import { useSelector } from 'react-redux';

export const useDashboardInformation = () => {
    const {
        isLoading,
        can_show_financial_info,
        is_customer,
        needFetchData,
        projectId,
        tabs,
        information,
        is_owner,
    } = useSelector(
        // @ts-ignore
        (state) => state.dashboardReducer
    );
    return {
        isLoading,
        can_show_financial_info,
        is_customer,
        projectId,
        tabs,
        needFetchData,
        information,
        is_owner,
    };
};
